import { render, staticRenderFns } from "./DetalleFactura.vue?vue&type=template&id=2f1d749c&scoped=true"
import script from "./DetalleFactura.vue?vue&type=script&lang=js"
export * from "./DetalleFactura.vue?vue&type=script&lang=js"
import style0 from "./DetalleFactura.vue?vue&type=style&index=0&id=2f1d749c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d749c",
  null
  
)

export default component.exports